<template>
  <div class="teacher_list">
    <div style="padding:20px;background:#fff;">
    <myTable :tableObj="tableObj" @btnClick="btnClick" @changePageNo="changePage"></myTable>
    </div>
    <!-- 退回意见 -->
    <el-dialog title="退回修改" :visible.sync="dialogVisible" width="600px" destroy-on-close>
      <div>
        <el-input
          class="textarea-width"
          maxlength="30"
          show-word-limit
          rows="6"
          type="textarea"
          v-model="examine_remark"
          placeholder
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deal('确认退回修改？','IdentityCertifieStatusReturned')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import myTable from "@/components/my_table";
export default {
  components: {
    myTable
  },
  data() {
    return {
      dialogVisible: false,
      examine_remark:'',
      row:null,//临时操作对象
      tableObj: {
        list: [], //列表数据
        btns: [
          //按钮组
          {
            name: "查看",
            funcName: "see"
          },
          {
            name: "通过",
            funcName: "pass",
            formatter: function(row) {
              return row.status === "IdentityCertifieStatusSubmitted";
            }
          },
          {
            name: "退回修改",
            funcName: "backEdit",
            formatter: function(row) {
              return row.status === "IdentityCertifieStatusSubmitted";
            }
          }
        ],
        table_detail: [
          {
            prop: "name",
            label: "教师名"
          },
          {
            prop: "faculty",
            label: "所在院系"
          },
          {
            prop: "professional_title_name",
            label: "职称"
          },
          {
            prop: "status_name",
            label: "认证状态"
          }
        ],
        layerpageinfo: {
          pageNo: 0,
          total: 0,
          pageSize: 10
        }
      }
    };
  },
  computed: {
    info() {
      return this.$store.state.info;
    },
    designer() {
      return this.$store.state.designer;
    }
  },
  created() {
    if (this.designer) {
      this.getTeacherManagerList();
    } else {
      this.needInfo("designer", "getTeacherManagerList");
    }
  },
  methods: {
    /* 监测信息 */
    needInfo(name, fn) {
      let watchAch = this.$watch(name, (val, oldVal) => {
        if (val) {
          this[fn]();
          watchAch(); //取消监听
        }
      });
    },
    // 老师列表
    getTeacherManagerList() {
      let params = Object.assign({}, this.tableObj.layerpageinfo, {
        school: this.designer.id
      });
      return new Promise(resolve => {
        this.api.getTeacherManagerList(params).then(res => {
          if (res.error.err_code !== 0) return;
          this.tableObj.list = res.obj.list || [];
          this.tableObj.layerpageinfo.total = res.obj.totalSize;
          resolve();
        });
      });
    },
    // 按钮组
    btnClick(btn) {
      this.row = btn.row;
      switch (btn.btnFuncName) {
        case "see":
          this.$router.push({
            name: "personal_center_teacher_mangaer_detail",
            query: {
              id: btn.row.id,
              code:btn.row.code
            }
          });
          break;
        case "pass":
         this.deal('确认通过？','IdentityCertifieStatussuccess');
          break;
        case "backEdit":
         this.dialogVisible = true;
          break;  
      }
    },
    // 操作提示
    deal(text, operation) {
      this.$confirm(`${text}`, "提示", {
        confirmButtonText: "继续",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.approvalBackTeacher(operation).then(res => {
            let _txt = "";
            if (operation === "IdentityCertifieStatussuccess") {
              _txt = "已通过!";
            } else if (operation === "IdentityCertifieStatusFailed") {
              _txt = "已不通过!";
            } else if (operation === "IdentityCertifieStatusReturned") {
              _txt = "已退回修改!";
              this.dialogVisible = false;
            }
            this.$message({
              type: "success",
              message: _txt
            });
            this.getTeacherManagerList();
          });
        })
        .catch(() => {});
    },
    // 教师认证操作
    approvalBackTeacher(operation) {
      return new Promise(resolve => {
        this.api
          .approvalBackTeacher({
            operation: operation,
            id: this.row.id,
            examine_remark: this.examine_remark
          })
          .then(res => {
            if (res.error.err_code != 0) return;
            resolve(res);
          });
      });
    },
    // 改变页数
    changePage(pageNo) {
      this.tableObj.layerpageinfo.pageNo = pageNo.val;
      this.getTeacherManagerList();
    }
  }
};
</script>

<style lang="scss" scoped>
.teacher_list {
}
</style>